import { useQuery } from '@tanstack/react-query';
import { getMainApi } from '../api/clients';
import { useAuthStore } from '../auth/authStore';

/**
 * Legacy bridge only. Account locations are UUIDs, but core-api-az product endpoints still
 * key on their own numeric ids, matched here through the practice-management `ascend_id`
 * (`external_id` on the core side).
 */
export interface CoreLocation {
  id: number;
  external_id: string;
  name: string;
  abbreviation: string;
  city: string;
  state: string;
  phone: string;
  email: string;
  full_address: string;
}

interface CoreLocationsResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: CoreLocation[];
}

/**
 * @param enabled Pass `false` in an app with no core-api endpoints, so the
 * call is never made. RCM is one: it talks to its own backend and to the
 * account app, and nothing else.
 */
export function useCoreLocations(enabled = true) {
  const status = useAuthStore((s) => s.status);
  const accessToken = useAuthStore((s) => s.accessToken);

  return useQuery<CoreLocation[]>({
    queryKey: ['core-locations'],
    queryFn: async () => {
      const response = await getMainApi().get<CoreLocationsResponse>(
        '/organization/api/locations/'
      );
      return response.data.results;
    },
    enabled: enabled && accessToken !== null && status === 'authenticated',
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
